<template>
  <div class="content">
    <el-row style="height:28px">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>考试培训</el-breadcrumb-item>
            <el-breadcrumb-item>考试管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!--  -->
          <div class="build-table">
            <div
              style="display:flex;border-top:10px solid #f5f5f5;width:100%;height:80px;align-items:center;justify-content: space-between;padding:0px 10px"
            >
              <el-input
                v-model="search.name"
                placeholder="请输入试卷名称"
                clearable
                @input="watchInput"
                style="width:220px;padding:10px"
              >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
              <el-button type="primary" icon="el-icon-plus" @click="addFun">添加试卷</el-button>
            </div>
            <!--  -->
            <div style="width:100%;height:calc(100% - 140px)">
              <el-table
                stripe
                :data="listData"
                height="100%"
                style="width: 100%;"
                :default-sort="{prop: 'createDate', order: 'descending'}"
                :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                :cell-style="rowClass"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column label="试卷名称">
                  <template slot-scope="scope">
                    <a>{{ scope.row.name}}</a>
                  </template>
                </el-table-column>
                <el-table-column label="试卷类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type==0">普通试卷</span>
                    <span v-if="scope.row.type==1">视频试卷</span>
                  </template>
                </el-table-column>
                <el-table-column label="考试类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.examType==1">线上考试</span>
                    <span v-else-if="scope.row.examType==2">WIFI考试</span>
                  </template>
                </el-table-column>
                <el-table-column label="开始时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.startTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="结束时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.endTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="handleDel(scope.$index, scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 添加试卷弹框 -->
              <!-- 新增窗口 -->
              <el-dialog
                :title="dialogTitle"
                :visible.sync="addFormVisible"
                center
                width="600px"
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
              >
                <el-form :model="addForm" label-width="200px" ref="addForm" label-position="right" :rules="rules">
                  <el-form-item label="题库选择：">
                    <el-select v-model="storeList" multiple placeholder="请选择">
                      <el-option
                        v-for="item in storeOpt"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="试卷名称：" prop="name">
                    <el-input v-model="addForm.name" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                   <el-form-item label="简介：" prop="remarks">
                    <el-input type="textarea" v-model="addForm.remarks" autocomplete="off" style="width:217px"></el-input>
                  </el-form-item>
                  <el-form-item label="考试类型：">
                    <el-radio v-model="addForm.examType" label="1">线上考试</el-radio>
                    <el-radio v-model="addForm.examType" label="2">WIFI考试</el-radio>
                  </el-form-item>
                  <el-form-item label="开始时间：" required>
                    <el-date-picker
                      v-model="addForm.startTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束时间：" required>
                    <el-date-picker
                      v-model="addForm.endTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="选题类型：">
                    <el-radio v-model="addForm.questType" label="1">自动选择</el-radio>
                    <el-radio v-model="addForm.questType" label="2">手动选择</el-radio>
                    <el-button
                      type="primary"
                      size="mini"
                      icon="el-icon-plus"
                      @click="addOpt"
                      v-if="addForm.questType=='2'"
                    >添加</el-button>
                  </el-form-item>
                  <el-form-item label style="width:100%;">
                    <ul class="con-box" v-if="addForm.questType=='1'">
                      <li class="box-item">
                        <div class="layui-inline">
                          <label class="layui-form-label">题数：</label>
                          <div class="layui-input-inline" style="width: 200px;">
                            <el-input v-model="strOpt1.num" placeholder="请输入内容"></el-input>
                          </div>
                        </div>
                        <div class="layui-inline">
                          <label class="layui-form-label">分数：</label>
                          <div class="layui-input-inline score" style="width: 200px;">
                            <el-input v-model="strOpt1.score" placeholder="请输入内容"></el-input>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul class="con-box" v-else-if="addForm.questType=='2'">
                      <li
                        class="box-item"
                        v-for="item in strOpt"
                        :key="item.index"
                        style="margin-bottom: 15px;"
                      >
                        <div class="layui-block">
                          <label class="layui-form-label">题型：</label>
                          <div class="layui-input-block type">
                            <el-radio v-model="item.type" label="1">单选题</el-radio>
                            <el-radio v-model="item.type" label="2">多选题</el-radio>
                            <el-radio v-model="item.type" label="3">判断题</el-radio>
                          </div>
                        </div>
                        <div class="layui-inline">
                          <label class="layui-form-label">题数：</label>
                          <div class="layui-input-inline" style="width: 200px;">
                            <el-input v-model="item.num" placeholder="请输入内容"></el-input>
                          </div>
                        </div>
                        <div class="layui-inline">
                          <label class="layui-form-label">分数：</label>
                          <div class="layui-input-inline" style="width: 200px;">
                            <el-input v-model="item.score" placeholder="请输入内容"></el-input>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-form-item>    
                  <el-form-item label="关联课程:" v-if="addForm.examType!='2'">
                    <el-checkbox-group v-model="videogroup"  @change="checkboxChange">
                      <el-checkbox v-for="item in vedioList" :key="item.videoId" :label="item.videoId">{{item.videoName}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="合格分：" prop="qualified">
                      <el-input v-model="addForm.qualified" style="width: 200px;" placeholder="请输入1-100"></el-input>
                  </el-form-item>
                  <el-form-item label="考试范围：" v-if="addForm.examType!='2'">
                    <el-radio-group v-model="addForm.scope" @change="agreeChange">
                      <el-radio label="0" v-if="groupType!='1'">企业考试</el-radio>
                      <el-radio label="1" v-if="groupType!='1'">项目考试</el-radio>
                      <el-radio label="2" v-if="groupType=='1'">班组考试</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="人员选择：" v-if="addForm.examType!='2'">
                    <el-tree
                      :data="person"
                      show-checkbox
                      node-key="id"
                      :default-checked-keys="checkData"
                      :props="defaultProps"
                      ref="tree"
                    ></el-tree>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="addFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                </div>
              </el-dialog>
            </div>
            <!-- 分页展示 -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10,20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
              ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    var checkscore = (rule, value, callback) => {
      if (value == '') {
          callback(new Error('请输入分数'))
      } else if (!this.isCellPhone(value)) {
          //引入methods中封装的检查手机格式的方法
          callback(new Error('请输入1-100之间!'))
      } else {
          callback()
      }
    }
    return {
      search: {
        //查询
        name: '',
        groupId: '',
      },
      listData: [], //表格数据
      addForm: {
        // groupType:'1',//组织类型，1项目，2施工企业，3建设企业
        id: '',
        name: '', //名称
        storeStr: '', //题库选择，题库id，用“,”隔开
        examType: '1', //考试类型，1线上考试
        startTime: '', //开始时间
        endTime: '', //结束时间
        questType: '1', //选题类型，1自动选题，2手动设置
        questStr: '', //题型选择，{"type":"题型","num":"题数","score":"分数"},
        type: '0', //试卷类型，0普通试卷，1视频试卷 (选择视频的时候传1，不选择传0)
        remarks: '', // 备注信息
        scope: '0', //考试范围，0内部人员考试，1项目考试 （展示企业内部人员，或者该企业下的人员）
        videoId: [], //视频id
        groupJson: '', //[{"id":"","projectId":""}] 考试JSON
        qualified:'' //合格分
      },
      videogroup:[],
      storeList: [], //题库列表
      dialogTitle: '',
      addFormVisible: false,
      groupId: '',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      storeOpt: [], //题库
      defaultProps: {
        //树形展示
        children: 'children',
        label: 'name',
      },
      person: [], //人员列表
      checkData: [], //选择的人员
      strOpt: [
        {
          index: '1',
          type: '',
          num: '',
          score: '',
        },
      ],
      strOpt1: {
        type: '',
        num: '',
        score: '',
      },
      dataText: '数据加载中...',
      rules: {
       remarks :[{ required: true, message: '请输入简介', trigger: 'blur' } ],
       name: [{ required: true, message: '请输入名称', trigger: 'blur' } ],
       qualified: [{ required: true, validator: checkscore, trigger: 'blur' }] //validator: checkphone是验证手机的引入checkphone函数
      },
      groupType: '',
      vedioList:[],
      roleId:'',
      groupId:''
    }
  },
  mounted() {
   
    this.groupId = util.session.get('groupId')
     this.roleId = util.session.get('roleId')
    // console.log(this.addForm.scope)
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.$store.commit('getRoleId')
      this.groupId = this.$store.state.groupId
      this.roleId = this.$store.state.roleId
    }
    // console.log(this.roleId)
    this.search.groupId = this.groupId
    if (this.roleId == '3') {
      this.groupType = '3'
    } else if (this.roleId == '4') {
      this.groupType = '1'
      this.addForm.scope = '1'
    } else if (this.roleId == '5') {
      this.groupType = '2'
    }
    // console.log(this.groupId)
    this.getData()
    this.getStore()
    this.getPerson()
    this.getVideo()
  },
  methods: {
    //查询
    doFilter() {
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    rowClass() {
      //表头居中显示
      return 'text-align:center'
    },
    //题库
    getStore() {
      var that = this
      myHttp
        .getAllStore({
          groupId: this.groupId,
          groupType: this.groupType,
          module:'enterprise',
          storeType:'1'
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.storeOpt = resp.data.data.storeList || []
          }
        })
    },
    // 获取数据
    getData() {
      var that = this
      this.search.groupId = this.groupId
      this.search.groupType = this.groupType
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.getPaperList(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            that.totalItems = resp.data.data.pageInfo.total || 0
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '服务器出错'
          }
        },
        function () {}
      )
    },
    //获取人员
    getPerson() {
      var that = this
      // if(this.groupType=='1'){
      //   myHttp.getEntTeams({
      //     projectId:this.groupId
      //   }).then(resp=>{
      //     var list = resp.data.data.list || []
      //     var tree = util.common.listToTree('id', 'parentId', list)
      //     this.person = tree
      //   })
      // }else{
      myHttp.entPersonList({
        groupId: this.groupId,
        scope: this.addForm.scope,
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.entity || []
          console.log(resp)
          var tree = util.common.listToTree('id', 'parentId', list)
          that.person = tree
        } else {
          this.$message.error(resp.msg)
        }
      },function () {})
      // }
    },
     // 获取视频课程
    getVideo(){
      var that = this
      if(this.groupType=='1'){
        myHttp.projectExamVideoProjectList({
          pageNum:1,
          pageSize:1000,
          projectId:this.groupId
        }).then(resp=>{
          if (resp.data.code == '200') {
            this.vedioList = resp.data.data.examVideoProjectList.list ||[]
          }
        })
      }else{
        myHttp.enterpriseExamVideoEntList({
          pageNum:1,
          pageSize:1000,
          entId:this.groupId
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.vedioList = resp.data.data.pageInfo.list ||[]
          } else {
              this.$message.error(resp.msg)
          }
        },function () {})
      }
      
    },
    //修改
    handleEdit(index, row) {
      this.dialogTitle = '修改试卷'
      var that = this
      myHttp
        .getPaperById({
          id: row.id,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.addFormVisible = true
            var data = resp.data.data.paper
            that.addForm.id = data.id
            that.addForm.name = data.name
            that.addForm.storeStr = data.storeStr
            that.storeList = data.storeStr.split(',')
            that.addForm.examType = data.examType
            that.addForm.startTime = data.startTime
            that.addForm.endTime = data.endTime
            that.addForm.questType = data.questType
            that.addForm.groupJson = data.groupJson
            that.addForm.questStr = data.questStr
            that.addForm.type = data.type
            that.addForm.scope =data.scope
            that.addForm.videoId = data.videoId
            that.addForm.qualified = data.qualified
            that.addForm.remarks = data.remarks
            // var persons = [] //人员
            that.checkData = []
            for (var i = 0; i < resp.data.data.paperTeams.length; i++) {
              that.checkData.push(resp.data.data.paperTeams[i].teamsId)
            }
            // console.log(that.checkData)
            if (data.questType == '1') {
              that.strOpt1 = resp.data.data.questStrList[0]
            } else {
              var str = resp.data.data.questStrList || []
              for (var i = 0; i < str.length; i++) {
                str[i].index = i
              }
              that.strOpt = str
            }
             var videoArr = []
             videoArr=that.addForm.videoId.split(',')
            //  console.log(videoArr)
             for(var i=0;i<videoArr.length;i++){
                 that.videogroup.push(videoArr[i]);
             }
            that.getPerson()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //保存
    sumbitAddRow(formName) {
      var that = this
      this.addForm.groupId = this.groupId
      this.addForm.groupType = this.groupType
      //获取题库
      if (this.storeList.length == 0) {
        this.$message.error('请选择考试题库')
        return
      }
      for (var i = 0; i < this.storeList.length; i++) {
        if (i == 0) {
          this.addForm.storeStr = this.storeList[i]
        } else {
          this.addForm.storeStr +=
            this.addForm.storeStr + ',' + this.storeList[i]
        }
      }
      //获取考试内容数据
      var questList = []
      if (this.addForm.questType == '1') {
        questList.push(this.strOpt1)
      } else {
        for (var i = 0; i < this.strOpt.length; i++) {
          var obj = {
            type: this.strOpt[i].type,
            num: this.strOpt[i].num,
            score: this.strOpt[i].score,
          }
          questList.push(obj)
        }
      }
      this.addForm.questStr = JSON.stringify(questList)
      //获取人员
      if(this.addForm.examType!='2'){
        var list = this.$refs.tree.getCheckedNodes()
        console.log(list)
        var personList = []
        if(this.groupType=='1'){
          for(var k=0;k<list.length;k++){
            if(list[k].teamsType!=''){
              var obj = {
                id:list[k].id,
                groupId:this.groupId,
                teamsId:list[k].id
              }
              personList.push(obj)
            }
          }
          this.addForm.groupJson = JSON.stringify(personList)
        }else if(this.addForm.scope==0){
          for (var i = 0; i < list.length; i++) {
            if (!list[i].isChild) {
              var obj = {
                id: list[i].id,
                groupId: list[i].groupId,
                teamsId:list[i].id
              }
              personList.push(obj)
            }
          }
          this.addForm.groupJson = JSON.stringify(personList)
        }else{
          for (var i = 0; i < list.length; i++) {
            if (!list[i].isChild) {
              var obj = {
                id: list[i].id,
                groupId: list[i].groupId,
                teamsId:list[i].id
              }
              personList.push(obj)
            }
          }
          this.addForm.groupJson = JSON.stringify(personList)
        }
      }else{
        var personList = []
        var obj = {
          id: this.groupId,
          groupId: this.groupId,
          teamsId:''
        }
        personList.push(obj)
        this.addForm.groupJson = JSON.stringify(personList)
      }
      
      if(this.addForm.examType=='2'){
        this.addForm.scope = '1'
      }else if (personList.length == 0) {
        this.$message.error('请选择参考人员')
        reutrn
      }
      if(this.addForm.videoId){
        this.addForm.type =1
      }else{
        this.addForm.type =0
      }
      // console.log(this.addForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!that.addForm.id) {
            myHttp.createPaper(that.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.addFormVisible = false
                that.$message.success('试卷创建成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          } else {
            myHttp.updatePaper(that.addForm).then(function (resp) {
              if (resp.data.code == '200') {
                that.addFormVisible = false
                that.$message.success('试卷修改成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          }
        }
      })
    },
    // handleNodeClick(data) {
    //   console.log(data)
    // },
    //添加
    addFun() {
      this.dialogTitle = '添加试卷'
      this.checkData = [];
      this.addForm = {
          id: '',
          name: '',
          storeStr: '',
          examType: '1',
          startTime: '',
          endTime: '',
          questType: '1',
          personJson: '',
          ProjectJson:'',
          questStr: '',
          type: '0',
          scope:'0',
          qualified:'',
          videoId:''
        },
        this.strOpt = [
          {
            index: '1',
            type: '',
            num: '',
            score: '',
          },
        ]
      this.strOpt1 = {
        type: '',
        num: '',
        score: '',
      }
      this.addFormVisible = true
    },
    //删除
    handleDel(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该试卷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp.delPaper({
            id:row.id
          }).then(function(resp){
            if(resp.data.code=="200"){
                that.$message.success('试卷删除成功');
                that.getData();
            }else{
                that.$message.error(resp.data.msg);
            }
          });
        })
        .catch((err) => {})
    },
    //添加选题
    addOpt() {
      var length = this.strOpt.length
      var index = parseInt(this.strOpt[length - 1].index) + 1
      var obj = {
        index: index,
        type: '',
        num: '',
        score: '',
      }
      this.strOpt.push(obj)
    },
    watchInput(e) {
      this.search.name= e
      this.getData()
    },
    agreeChange(val){
      // console.log(val)
      this.search.scope =val
      this.getPerson()
    },
    checkboxChange(val){
      // console.log(val)
      this.videogroup =val
        for(var i = 0;i<val.length;i++){ 
          // console.log(val.length)
        if (i == 0) {
          this.addForm.videoId = val[i]
        } else {
          this.addForm.videoId +=
          this.addForm.videoId + ',' + val[i]
        }
  
        }
        // console.log( this.addForm.videoId)
    },
    // 检查分数
    isCellPhone(val) {
        var reg = new RegExp("^(\\d|[1-9]\\d|100)$");
        if(!reg.test(val)) {
          return false
        }else{
          return true
        }

    },
  },
   
}
</script>
<style>
  @import '../../assets/css/common.css';
  .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: #ecf0f5;
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #fff;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-table th > .cell {
  text-align: center !important;
}
</style>